/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UiApiClient from "../../../Basis/Api/UiApiClient";
import ResponseUtil from "../../../Basis/Utils/ResponseUtil";

export default class AuftragsverarbeitungsvertragClient extends UiApiClient {
    public constructor() {
        super("auftragsverarbeitungsvertrag");
    }

    public async stelleSicher(): Promise<File> {
        const response = await this.post("stelleSicher");
        return ResponseUtil.toFile(response);
    }
}